export const SEARCH_FILTERS = [
  { value: 'payment_id', label: 'Payment ID' },
  { value: 'amount', label: 'Amount' },
];

export const STATUS_PAID = 'Paid';
export const STATUS_INITIATED = 'Initiated';
export const STATUS_PROCESSED = 'Processed';
export const STATUS_IN_TRANSIT = 'In Transit';
export const STATUS_FAILED = 'Failed';
export const STATUS_PENDING = 'Pending';
export const STATUS_CANCELLED = 'Cancelled';

export const STATUS_FILTERS = [
  { label: 'Paid', value: STATUS_PROCESSED },
  { label: 'Failed', value: STATUS_FAILED },
  { label: 'Pending', value: STATUS_PENDING },
  { label: 'Initiated', value: STATUS_INITIATED },
  { label: 'Cancelled', value: STATUS_CANCELLED },
  { label: 'In Transit', value: STATUS_IN_TRANSIT },
];
